import React from 'react';

/**
 * Planet Research Panel — summary per planet over the timeline window.
 *
 * Props:
 *   - summary: timeline.planet_summary array
 *   - onClickPlanet: (planet_en) => void
 */

const COLOR = {
  Sun: 'from-amber-500/20 to-amber-700/5 border-amber-400/40 text-amber-200',
  Moon: 'from-slate-400/20 to-slate-600/5 border-slate-300/40 text-slate-200',
  Mars: 'from-red-500/20 to-red-700/5 border-red-400/40 text-red-200',
  Mercury: 'from-emerald-500/20 to-emerald-700/5 border-emerald-400/40 text-emerald-200',
  Jupiter: 'from-yellow-500/20 to-yellow-700/5 border-yellow-400/40 text-yellow-200',
  Venus: 'from-pink-500/20 to-pink-700/5 border-pink-400/40 text-pink-200',
  Saturn: 'from-zinc-500/20 to-zinc-700/5 border-zinc-400/40 text-zinc-200',
  Rahu: 'from-purple-500/20 to-purple-700/5 border-purple-400/40 text-purple-200',
  Ketu: 'from-fuchsia-500/20 to-fuchsia-700/5 border-fuchsia-400/40 text-fuchsia-200',
};

export default function PlanetResearchPanel({ summary = [], onClickPlanet }) {
  if (!summary || summary.length === 0) return null;
  return (
    <div data-testid="planet-research-panel" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      {summary.map(p => {
        const color = COLOR[p.planet_en] || 'from-white/10 to-white/0 border-white/20 text-white';
        return (
          <button
            key={p.planet_en}
            data-testid={`research-${p.planet_en}`}
            onClick={() => onClickPlanet && onClickPlanet(p.planet_en)}
            className={`text-left rounded-xl border bg-gradient-to-br ${color} p-4 hover:brightness-125 transition-all`}
          >
            <div className="flex items-center justify-between mb-3">
              <h4 className="font-heading text-lg">{p.planet_hi}</h4>
              <span className="text-[10px] uppercase tracking-wider opacity-70">{p.planet_en}</span>
            </div>
            <div className="text-xs space-y-1 opacity-90">
              <div className="flex justify-between"><span className="opacity-60">वर्तमान:</span><span>{p.current_sign_hi}</span></div>
              <div className="flex justify-between"><span className="opacity-60">अगला:</span><span>{p.next_sign_hi ?? '—'}</span></div>
              {p.next_change_dt_ist && <div className="font-mono text-[10px] opacity-70">{p.next_change_dt_ist}</div>}
            </div>
            <div className="mt-3 grid grid-cols-3 gap-1.5 text-center">
              <Stat n={p.total_sign_changes} l="राशि" />
              <Stat n={p.total_nakshatra_changes} l="नक्षत्र" />
              <Stat n={p.total_pada_changes} l="पाद" />
              <Stat n={p.total_retrograde_periods} l="वक्री" />
              <Stat n={p.total_combust_periods} l="अस्त" />
            </div>
          </button>
        );
      })}
    </div>
  );
}

const Stat = ({ n, l }) => (
  <div className="rounded-md bg-black/30 border border-white/10 px-1 py-1">
    <div className="text-sm font-bold leading-none">{n}</div>
    <div className="text-[9px] opacity-60 mt-0.5">{l}</div>
  </div>
);
